import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import FormCheckbox from './form_checkbox.js';
import Utils from './utils.js';

class FormCheckboxMultiple extends Component {
  onChange(option, value) {
    const vals = this.props.value || [];

    if (value) {
      if (!vals.includes(option)) vals.push(option);
    } else {
      if (vals.includes(option)) {
        var index = vals.indexOf(option);
        if (index > -1) {
          vals.splice(index, 1);
        }
      }
    }
    this.props.onChange(vals);
  }

  render() {
    // {type: "checkbox", label: "Surname", key: "surname", options: Array(3)}
    const {
      label, name, value, options, onChange, showLabel,
    } = this.props;

    const text = label
      || name
        .split('_')
        .map(x => Utils.capitalize(x))
        .join(' ');

    const enableLabel = showLabel && !!text;
    const values = Array.isArray(value) ? value : [value];
    return (
      <div className="form-group">
        {enableLabel && <label className="col-sm-3 control-label">{text}</label>}
        <div className="col-sm-9">
          {options.map((opt, i) => (
            <div className={`form-group ${Utils.classStyle(this.props, '')}`} key={i}>
              <input
                type="checkbox"
                name={name}
                onChange={event => this.onChange(opt[0], event.target.checked)}
                value={opt[0]}
                checked={_.includes(values, opt[0])}
              />
              <label className="col-sm-3 control-label">{opt[0]}</label>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

FormCheckboxMultiple.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  classStyle: PropTypes.string,
  capitalize: PropTypes.bool,
  showLabel: PropTypes.bool,
};

FormCheckboxMultiple.defaultProps = {
  capitalize: false,
};

export default FormCheckboxMultiple;
